import { Component, OnInit } from '@angular/core';
import {
  BaseDesignerControl,
  IControl,
  TrDesignerControl,
} from '@transfora/form-designer';
import { TrDialogService } from '@transfora/core';

@Component({
  selector: 'app-custom-button',
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.scss'],
})
@TrDesignerControl({ type: 'custombutton' })
export class CustomButtonComponent extends BaseDesignerControl<IControl> {
  constructor(public trDialogService: TrDialogService) {
    super(trDialogService);
  }
}
